import React from 'react';
import { PropTypes } from 'prop-types';

import ModalWrapper from 'components/Modals/ModalWrapper';

const WhdAiProcessingModal = ({ isOpen, onClose, onNavigateToAdvanced, fileName }) => (
  <ModalWrapper
    headerClose
    isOpen={ isOpen }
    title="Withholding Statement Processing"
    btnConfirmTitle="Go to Advanced WHS"
    btnConfirmClass="btn-primary"
    btnCancelTitle="Close & Check Later"
    btnCancelClass="btn-secondary"
    onConfirm={ onNavigateToAdvanced }
    onCancel={ onClose }
  >
    <div className="alert alert-info">
      <strong>Your statement is being processed</strong>
    </div>
    <p>
      The withholding statement <strong>&quot;{ fileName }&quot;</strong> has been uploaded and is currently being processed by our AI engine.
    </p>
    <h3 className="mt-3">How to track progress:</h3>
    <ol>
      <li>Navigate to <strong>ADVANCED → WHS Management</strong></li>
      <li>Look for your document in the list</li>
      <li>Check the status column to see processing progress</li>
      <li>Once complete, the statement will be available for review</li>
    </ol>
  </ModalWrapper>
);

WhdAiProcessingModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onNavigateToAdvanced: PropTypes.func.isRequired,
  fileName: PropTypes.string
};

WhdAiProcessingModal.defaultProps = {
  fileName: 'Withholding Statement'
};

export default WhdAiProcessingModal;
